export default function isMultipleOf(value, multiple) {
    return (value % multiple) === 0;
}
